import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type {
  CourseProgressLessonsStudentData,
  CourseProgressSpellingStudentData,
} from 'teacher-ui-client/components/giraffe/charts/course-progress/student'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface CourseProgressSpellingStudentResponse {
  course_progress_events: {
    category: 'lessons' | 'assignments'
    lesson_number: number
    score: number
    created_at: number
  }[]
  course_progress_events_summary: {
    data: [{ category: 'total_count'; count: number }, { category: 'highest_count'; count: number }]
  }
}

export async function courseProgressSpellingStudent(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  precinct: LegacyPrecinctSpelling,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressSpellingStudentData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_events', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct })

  const data = await this.fetchData<CourseProgressSpellingStudentResponse>(url, query)
  if (!data) return null

  const { course_progress_events_summary, course_progress_events } = data
  if (course_progress_events.length === 0) return null

  const total_count = course_progress_events_summary.data.find((d) => d.category === 'total_count')!.count
  const highest_count = course_progress_events_summary.data.find((d) => d.category === 'highest_count')!.count

  return {
    summary: {
      total_count,
      highest_count,
    },
    events: course_progress_events,
  }
}

export interface CourseProgressLessonsStudentResponse {
  course_progress_events: {
    category: 'lessons' | 'assignments'
    lesson_number: number
    created_at: number
  }[]
  course_progress_events_summary: {
    data: [{ category: 'total_count'; count: number }]
  }
}

export async function courseProgressLessonsStudent(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  precinct: LegacyPrecinctReading | LegacyPrecinctMyLessons | LegacyPrecinctLessons,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressLessonsStudentData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_events', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct })

  const data = await this.fetchData<CourseProgressLessonsStudentResponse>(url, query)
  if (!data) return null

  const { course_progress_events_summary, course_progress_events } = data
  if (course_progress_events.length === 0) return null

  const total_count = course_progress_events_summary.data.find((d) => d.category === 'total_count')!.count

  return {
    summary: {
      total_count,
    },
    events: course_progress_events,
  }
}
